import type { LucideIcon } from 'lucide-react';
import {
  Bookmark, BookOpen, Cake, Cat, Cherry, CloudRain, Coffee,
  Gift, Heart, Music, PartyPopper, Pencil, Pizza, Salad,
  Sandwich, Store, Sun, TreeDeciduous, Wheat, Wrench,
} from 'lucide-react';

/** 自定义事件可选图标（4×5）；emoji 写入后端 activity_emoji */
export type CustomActivityIconChoice = {
  id: string;
  emoji: string;
  Icon: LucideIcon;
};

export const CUSTOM_ACTIVITY_ICON_CHOICES: CustomActivityIconChoice[] = [
  { id: 'cake',       emoji: '🎂',  Icon: Cake },
  { id: 'wrench',     emoji: '🔧',  Icon: Wrench },
  { id: 'sandwich',   emoji: '🥪',  Icon: Sandwich },
  { id: 'pizza',      emoji: '🍕',  Icon: Pizza },
  { id: 'tree',       emoji: '🌳',  Icon: TreeDeciduous },
  { id: 'cat',        emoji: '🐱',  Icon: Cat },
  { id: 'store',      emoji: '🏪',  Icon: Store },
  { id: 'wheat',      emoji: '🌾',  Icon: Wheat },
  { id: 'cloud_rain', emoji: '🌧️', Icon: CloudRain },
  { id: 'pencil',     emoji: '✏️', Icon: Pencil },
  { id: 'coffee',     emoji: '☕',  Icon: Coffee },
  { id: 'cherry',     emoji: '🍒',  Icon: Cherry },
  { id: 'bookmark',   emoji: '🔖',  Icon: Bookmark },
  { id: 'salad',      emoji: '🥗',  Icon: Salad },
  { id: 'sun',        emoji: '☀️', Icon: Sun },
  { id: 'party',      emoji: '🎉',  Icon: PartyPopper },
  { id: 'heart',      emoji: '❤️', Icon: Heart },
  { id: 'music',      emoji: '🎵',  Icon: Music },
  { id: 'book',       emoji: '📖',  Icon: BookOpen },
  { id: 'gift',       emoji: '🎁',  Icon: Gift },
];
